module.exports = Jodit;


//////////////////
// WEBPACK FOOTER
// external "Jodit"
// module id = 1636
// module chunks = 